export default __webpack_public_path__ + "static/portfolio_gallery_1-6757bea3ea54d93bab84c28de7790c6b.jpg";